import { UserIdha, Account, Address, Vehicle, GrupoDeClientes } from "@idha/idha-types"
import { FiltersAppliedOrderManagement, StateListMenuSelections, StateSituations, StateOrigin } from "modules/app/reactComponents/orders/management"
import { PurchaseType, StateSituationsPurchase } from "modules/app/reactComponents/orders/management/purchase-management/components/container/PurchaseManagementRightMenuContainer"
import { BuyerListOrder, BuyerListStatus } from 'modules/app/reactComponents/orders/purchase/buyer-list-menu/components/presentation/BuyerListMenu'
import { StatusSituation, StatusStandartCost } from "modules/app/reactComponents/pricing/product-acquisition-cost"
import { AccessPermissions } from "../modules/app/acces-rules"
import { Filters } from "../modules/app/reactComponents/register/ProductManagementListMenu/components/presentation/ProductManagementListMenu"
import { FilterOrderdenate, IdMenuSelections } from "modules/app/reactComponents/orders/expedition/menu/types"
import { ISituationFilter } from "modules/app/reactComponents/orders/expedition/components/container/ExpeditionContainer"


class PersonInformation {
  constructor(
    public id: string = null,
    public permissions: {
      id: string,
      identifier: string
    }[] = [],
    public isAgency: boolean = false,
    public isBank: boolean = false,
    public isClient: boolean = false,
    public ownerId: string = '',
    public bankId: string = null
  ) { }
}

export class LoggedUser implements UserIdha {
  constructor(
    public token: string = null,
    public isLogged: boolean = false,
    public email: string = null,
    public emailVerified: boolean = null,
    public id: string = null,
    public lastAccess: Date = null,
    public name: string = null,
    public personId: string = null,
    public isAdmin: boolean = false,
    public allowAccessBank: boolean = false,
    public allowAccessAgency: boolean = false,
    public rg: string = null,
    public cpf: string = null,
    public address: Address = null,
    public vehicles: Vehicle[] = null,
    public phone?: string,
    public cellphone?: string,
    public phoneOthers?: string,
    public phoneComercial?: string,
    public roles: {
      id: string,
      name: string
    }[] = [],
    public personInformation: PersonInformation = new PersonInformation(),
    public username: string = null,
    public currentPhoto: {
      filename?: string
    } = {}
  ) { }

  reset() {
    this.isLogged = false
    this.email = null
    this.emailVerified = null
    this.id = null
    this.lastAccess = null
    this.name = null
    this.personId = null
    this.roles = []
    this.username = null
    this.address = null;
    this.rg = null;
    this.cpf = null;
    this.vehicles = []
    this.currentPhoto = {}
    this.personInformation = new PersonInformation()
  }

  

  

  isAgency() {
    return this.personInformation.isAgency
  }

  isBank() {
    return this.personInformation.isBank
  }
}

export class TopbarButton {
  constructor(
    public icon?: string,
    public name?: string,
    public action?: Function,
    public isDivider?: boolean,
    public fontAwesome?: boolean,
    public fontAwesomePrefix?: 'fa' | 'fas' | 'fab' | 'far' | 'fal' | 'fad'
  ) {
    this.icon = icon || null
    this.name = name || null
    this.action = action || null
    this.isDivider = isDivider || false
    this.fontAwesome = fontAwesome || false
    this.fontAwesomePrefix = fontAwesomePrefix || 'fa'
  }
}

export class TopbarStructure {

  constructor(
    public showSearchButton = false,
    public showSearchBar = false,
    public show = false,
    public hasNavMenu = false,
    public navList: string[] = [],
    public refreshFunction: Function = undefined,
    public buttons: TopbarButton[] = [],
    public menuItems: TopbarButton[] = [],
    public onSearchTextChangeFunction: Function = undefined,
    public searchPlaceHolder: string = undefined,
    public searchText: string = '',
    public showBackButton = false,
    public showHomeButton = false
  ) { }
}

export class PageStrucuture {
  constructor(
    public title = null
  ) { }
}
export class ToastStructure {
  constructor(
    public show = false,
    public message = '',
    public onClose: () => void = undefined,
  ) { }
}

export class RightMenuStructure {
  constructor(public show: boolean = false) {

  }
}

export class LeftMenuStructure {
  constructor(
    public show: boolean = false) {
  }
}

export class UsersStructure {
  userList: UserIdha[]
  exchangeUserVisible: boolean
}

export class OrderManagementRightMenuStructure {
  constructor(
    public initialDate: Date = null,
    public finalDate: Date = null,
    public stateSituations: StateSituations = null,
    public stateListMenuSelections: StateListMenuSelections = null,
    public filtersAppliedOrderManagement: FiltersAppliedOrderManagement = null,
    public stateListOrigin: StateOrigin[] = []
  ) { }
}

export class BuyerListRightMenuStructure {
  constructor(
    public stateMenu: boolean = false,
    public purchaseDate: Date = null,
    public showDetails: boolean = false,
    public status: BuyerListStatus = {
      pendente: false,
      concluido: false
    },
    public order: BuyerListOrder = {
      code: false,
      name: false,
      displayOrder: true
    }
  ) { }
}

export class ClientLinkQrCodeDialogStructure {
  constructor(
    public qrCodeApiUrl: string = '',
    public qrCodeApiUrlLink: string = '',
    public show: boolean = false
  ) { }
}


export class ProductAcquisitionCostRightMenuStructure {
  constructor(
    public stateMenu: boolean = false,
    public situacao: StatusSituation = {
      atualizados: false,
      naoAtualizados: false
    },
    public custoPadrao: StatusStandartCost = {
      comCusto: false,
      semCusto: false
    },
    public filters: Filters = {
      code: false,
      displayOrder: false,
      name: false
    }
  ) { }
}


export class ProductManagementListMenuStructure {
  constructor(
    public stateMenu: boolean = false,
    public situacao: StatusSituation = {
      atualizados: false,
      naoAtualizados: false
    },
    public custoPadrao: StatusStandartCost = {
      comCusto: false,
      semCusto: false
    },
    public filters: Filters = {
      code: false,
      displayOrder: false,
      name: false
    }
  ) { }
}

export class PurchaseManagementRightMenuStructure {
  constructor(
    public stateMenu: boolean = false,
    public initialDate: Date = null,
    public finalDate: Date = null,
    public stateSituations: StateSituationsPurchase = null,
    public providerId: string = '',
    public stateType: PurchaseType[] = [{
      name: "",
      state: false,
      translate: ""
    }]
  ) { }
}

export class ExpeditionRightMenuStructure {
  constructor(
    public stateMenu: boolean = false,
    public initialDate: Date = null,
    public finalDate: Date = null,
    public situations: ISituationFilter = {
      PENDENTE: true,
      EM_ANDAMENTO: true,
      CONCLUIDO: true,
      CANCELADO: false,
      ALL: false,
    },
    public idMenuSelections: IdMenuSelections = {
      cargoId: "",
      clientId: "",
      local: "",
      productId: "",
      documentNumber: ""
    },
    public ordernateFilter: FilterOrderdenate = {
      cliente: false,
      ordem: true,
      local: false,
      embalagem: false,
      prioridade: false,
      produto: false,
    }
  ) { }
}

export class ShipmentsRightMenuStructure {
  constructor(
    public initialDate: Date = null,
    public finalDate: Date = null,
    public situations = {
      PENDENTE: true,
      EM_ANDAMENTO: true,
      CONCLUIDO: true,
      CANCELADO: false,
      ALL: false
    },
    public idMenuSelections: IdMenuSelections = {
      cargoId: "",
      clientId: "",
      local: "",
      productId: "",
      documentNumber: ""
    },
  ) { }
}

export class StoreStructure {
  topbar: TopbarStructure
  toast: ToastStructure
  loggedUser: LoggedUser
  page: PageStrucuture
  leftMenu: LeftMenuStructure
  rightMenu: RightMenuStructure
  users: UsersStructure
  accessPermissions: AccessPermissions
  selectedAccount: Account
  dispatch: Function
  orderManagementRightMenu: OrderManagementRightMenuStructure
  buyerListRightMenu: BuyerListRightMenuStructure
  clientLinkQrCodeDialog: ClientLinkQrCodeDialogStructure
  productAcquisitionCostRightMenu: ProductAcquisitionCostRightMenuStructure
  productManagementListMenu: ProductManagementListMenuStructure
  purchaseManagementRightMenu: PurchaseManagementRightMenuStructure
  expeditionRightMenu: ExpeditionRightMenuStructure
  shipmentRightMenu: ShipmentsRightMenuStructure
}



export class Foo {
  constructor(
    public bar: string = null
  ) { }
}


